const BASE_URL = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/editor/layout-example/`;

export const MACRO_LAYOUT_1 = {
  version: '7.1.0',
  objects: [
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'background',
      selectable: false,
      evented: false,
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 960,
      width: 1080,
      height: 1920,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${BASE_URL}background.png`,
      crossOrigin: null,
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'logo',
      selectable: true,
      evented: true,
      assignedAnimation: 'slideDown',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 1542,
      width: 1349,
      height: 276,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.2856,
      scaleY: 0.2856,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${BASE_URL}logo.png`,
      crossOrigin: null,
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'asset-00',
      selectable: true,
      evented: true,
      assignedAnimation: 'slideRight',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 960,
      width: 1582,
      height: 1581,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.5064,
      scaleY: 0.5064,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${BASE_URL}asset-00.png`,
      crossOrigin: null,
      filters: []
    },
    {
      fontSize: 100,
      fontWeight: 'bold',
      fontFamily: "'DM Sans', sans-serif",
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: 'Abri tu cuenta\ny comprá en dólares\nen un clic',
      charSpacing: 0,
      textAlign: 'left',
      styles: [
        {
          start: 14,
          end: 43,
          style: {
            fontSize: 90,
            fontWeight: 'bold',
            fontFamily: "'DM Sans', sans-serif",
            fontStyle: 'normal',
            underline: false,
            overline: false,
            linethrough: false,
            stroke: null,
            strokeWidth: 1,
            fill: '#ffffff',
            deltaY: 0,
            textBackgroundColor: '',
            textDecorationThickness: 66.667
          }
        }
      ],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      pieceId: 'text-0',
      selectable: true,
      evented: true,
      assignedAnimation: 'slideLeft',
      type: 'IText',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 368.2782,
      width: 898.9988,
      height: 350.752,
      fill: '#ff6bd0',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },
    {
      fontSize: 72,
      fontWeight: 'bold',
      fontFamily: "'DM Sans', sans-serif",
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: 'Hacé rendir tu plata',
      charSpacing: 0,
      textAlign: 'left',
      styles: [
        {
          start: 5,
          end: 11,
          style: {
            fill: '#ff61d5'
          }
        }
      ],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      pieceId: 'text-03',
      selectable: true,
      evented: true,
      assignedAnimation: 'fadeIn',
      type: 'IText',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 1405.8574,
      width: 701.5216,
      height: 81.36,
      fill: '#ffffff',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    }
  ],
  background: '#f0f0f0'
};
